import {NgModule} from '@angular/core';
import {ApolloModule, NamedOptions, APOLLO_NAMED_OPTIONS} from 'apollo-angular';
import {ApolloLink, InMemoryCache} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import {environment} from '../environments/environment';
import { offsetLimitPagination } from "@apollo/client/utilities";
import {setContext} from "@apollo/client/link/context";
import {onError} from "@apollo/client/link/error";
import extractFiles from 'extract-files/extractFiles.mjs';
import isExtractableFile from 'extract-files/isExtractableFile.mjs';

const uri = environment.graphqlUrl; // <-- add the URL of the GraphQL server here
const internalUri = environment.graphqlUrlInternal; // <-- add the URL of the GraphQL server here

export function createApollo(httpLink: HttpLink): NamedOptions {

  const auth = setContext((_, {headers, ...context}) => {
    // console.log('setting context');
    const token = localStorage.getItem('access_token');
    if (token === null) {
      return {};
    } else {
      return {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    }
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`,
        ),
      );
    if (networkError) console.log(`[Network error]: ${networkError}`, networkError);

    networkError = null;

  });

  let uploadLink = httpLink.create({
    uri: internalUri,
    // @ts-ignore
    extractFiles: (body) => extractFiles(body, isExtractableFile),
  });

  return {
    default: {
      cache: new InMemoryCache({
        typePolicies: {
          Query: {
            fields: {
              jobs: offsetLimitPagination()
            }
          },
          Profile: {
            keyFields: ['uuid']
          }
        }
      }),
      link: httpLink.create({
        uri,
        // enables file uploads for mutations sent with context useMultipart
        // @ts-ignore
        extractFiles: (body) => extractFiles(body, isExtractableFile),
      })
    },
    internalClient: {
      cache: new InMemoryCache(),
      link: ApolloLink.from([errorLink, auth, uploadLink]),
      defaultOptions: {
        query: {
          fetchPolicy: 'no-cache'
        }
      }
    }
  };
}

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_NAMED_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
